import type { ScheduleTemplateTime } from "@/pages/human-resources/time-management/business/schedule-template/ScheduleTemplateTime.ts";
import { immerable } from "immer";
import { AbstractTimeSlot } from "@/pages/human-resources/time-management/business/time-slot/AbstractTimeSlot.ts";
import type { HourlyTagCategory } from "@/pages/human-resources/time-management/business/hourly-tag/HourlyTagCategory.ts";

export class TemplateTimeSlot extends AbstractTimeSlot {
  [immerable] = true;

  constructor(
    category: HourlyTagCategory | undefined,
    positionId: string | undefined,
    breakDurationMinutes: number,
    public readonly startTime: ScheduleTemplateTime,
    public readonly endTime: ScheduleTemplateTime,
  ) {
    super(category, positionId, breakDurationMinutes);
  }

  public sameValueAs(other: TemplateTimeSlot | undefined): boolean {
    return (
      other !== undefined &&
      super.sameValueAs(other) &&
      this.startTime.sameValueAs(other.startTime) &&
      this.endTime.sameValueAs(other.endTime)
    );
  }

  public buildKey(): string {
    return `${this.startTime.toString()}_to_${this.endTime.toString()}`;
  }

  protected durationMinutes(): number {
    return this.endTime.durationMinutes() - this.startTime.durationMinutes();
  }

  public overlapsAnyOf(slots: TemplateTimeSlot[]): boolean {
    return slots.some((s) => s != this && this.overlaps(s));
  }

  public overlaps(other: TemplateTimeSlot): boolean {
    const start = this.startTime.toMillis();
    const end = this.endTime.toMillis();
    const otherStart = other.startTime.toMillis();
    const otherEnd = other.endTime.toMillis();
    const lower = Math.max(start, otherStart);
    const upper = Math.min(end, otherEnd);
    return lower < upper;
  }
}
